import React, { useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import { ui } from '../utils/styles';

const ModalReajusteFaturamento = ({ show, onClose }) => {
    const [reajustarPorcentagem, setReajustarPorcentagem] = useState(false);
    const [porcentagem, setPorcentagem] = useState('');

    const [atualizarValor, setAtualizarValor] = useState(false);
    const [valorAtual, setValorAtual] = useState('');
    const [novoValor, setNovoValor] = useState('');

    const [loading, setLoading] = useState(false);

    const URL_BACKEND = process.env.REACT_APP_URL_BACKEND;

    if (!show) return null;

    const handleSubmit = async () => {
        if (!reajustarPorcentagem && !atualizarValor) {
            toast.error('Selecione ao menos uma opção de reajuste.');
            return;
        }

        setLoading(true);

        try {
            await axios.post(
                `${URL_BACKEND}/atualiza-faturamento`,
                {
                    reajustarPorcentagem,
                    porcentagem: reajustarPorcentagem ? Number(porcentagem) : null,
                    atualizarValor,
                    valorAtual: atualizarValor ? Number(valorAtual) : null,
                    novoValor: atualizarValor ? Number(novoValor) : null,
                },
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('userToken')}`,
                    },
                }
            );

            toast.success('Faturamento atualizado com sucesso!');
            onClose();
        } catch (e) {
            toast.error(e?.response?.data?.message || 'Erro ao atualizar faturamento.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={ui.modalReajuste}>
            <div style={ui.modalCard}>
                <h2 style={{ marginBottom: 16 }}>Reajuste de Faturamento</h2>

                {/* Reajuste por porcentagem */}
                <label style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    fontSize: 14,
                    fontWeight: 500,
                    color: '#111827',
                    cursor: 'pointer',
                    marginBottom: 8,
                }}>
                    <input
                        type="checkbox"
                        style={{ cursor: 'pointer' }}
                        checked={reajustarPorcentagem}
                        onChange={e => setReajustarPorcentagem(e.target.checked)}
                    />
                    Reajustar por porcentagem
                </label>

                {reajustarPorcentagem && (
                    <input
                        style={ui.input}
                        type="number"
                        placeholder="Ex.: 10 para 10%"
                        value={porcentagem}
                        onChange={e => setPorcentagem(e.target.value)}
                    />
                )}

                <hr style={{ margin: '16px 0' }} />

                {/* Substituir valor */}
                <label style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    fontSize: 14,
                    fontWeight: 500,
                    color: '#111827',
                    cursor: 'pointer',
                    marginBottom: 8,
                }}>
                    <input
                        type="checkbox"
                        style={{ cursor: 'pointer' }}
                        checked={atualizarValor}
                        onChange={e => setAtualizarValor(e.target.checked)}
                    />
                    Substituir valor
                </label>

                {atualizarValor && (
                    <div style={{ display: 'flex', gap: 8 }}>
                        <input
                            style={ui.input}
                            type="number"
                            placeholder="Valor atual (ex: 500)"
                            value={valorAtual}
                            onChange={e => setValorAtual(e.target.value)}
                        />
                        <input
                            style={ui.input}
                            type="number"
                            placeholder="Novo valor (ex: 550)"
                            value={novoValor}
                            onChange={e => setNovoValor(e.target.value)}
                        />
                    </div>
                )}

                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 24 }}>
                    <button style={ui.buttonLight} onClick={onClose} disabled={loading}>
                        Cancelar
                    </button>
                    <button style={ui.buttonPrimary} onClick={handleSubmit} disabled={loading}>
                        {loading ? 'Processando...' : 'Atualizar'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ModalReajusteFaturamento;
